<template>
  <!-- Icon template file -->
  <div class="icon-buffer-container" :class="{ disabled: disabled }">
    <div class="perimeter">
      <div class="center"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
defineOptions({ name: 'IconBuffer' })

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)
</script>
<style scoped lang="scss" src="./icon-buffer.scss"></style>
